import React, { useState } from "react";
import { Dropdown, DropdownItem, DropdownMenu } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { far } from "@fortawesome/pro-regular-svg-icons";
import useI18n from "../hooks/useI18n";
import useReloader from "../hooks/useReloader";
import PropTypes from "prop-types";

const LocaleDropdownSelector = (props) => {
    const [showDropdown, setShowDropdown] = useState(false);
    const { getLocale, getLanguages, getLanguageLabel } = useI18n();
    const userLocale = getLocale();
    const { reload } = useReloader();

    /**
     * Switch the language and reload the page.
     * @param {string} locale
     */
    const switchLang = (locale) => {
        localStorage.setItem('locale', locale);
        reload();
    }

    const chevronElement = showDropdown
        ? (<FontAwesomeIcon icon={far.faChevronUp} />)
        : (<FontAwesomeIcon icon={far.faChevronDown} />);

    return (
        <Dropdown show={showDropdown} onToggle={setShowDropdown} className="login-language language-dropdown">
            <Dropdown.Toggle id="locale-dropdown-toggle" className="login-language btn-login-language">
                {!props.hideChevron && chevronElement}
                &nbsp;
                {getLanguageLabel(userLocale)}
            </Dropdown.Toggle>
            <DropdownMenu className="login-language">
                {getLanguages().map(language => (
                    userLocale !== language && <DropdownItem
                        key={`language-dropdown-item-${language}`}
                        className="login-language btn btn-language-dropdown"
                        onClick={() => switchLang(language)}>
                        {getLanguageLabel(language)}
                    </DropdownItem>
                ))}
            </DropdownMenu>
        </Dropdown>
    )
}

LocaleDropdownSelector.propTypes = {
    hideChevron: PropTypes.bool
}

export default LocaleDropdownSelector;
